(function(){
  function reveal(root){
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = (root||document).querySelectorAll('.aveline-page .reveal:not(.in)');
    if(reduce || !('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('in');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, {threshold:0.12, rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(e){ io.observe(e); });
  }
  function menus(root){
    (root||document).querySelectorAll('[data-av-burger]').forEach(function(b){
      if(b._avb) return; b._avb=true;
      b.addEventListener('click', function(){ var m=document.getElementById(b.getAttribute('data-av-burger')); if(m) m.classList.toggle('open'); });
    });
    (root||document).querySelectorAll('.aveline-page .menu').forEach(function(m){
      if(m._avm) return; m._avm=true;
      m.addEventListener('click', function(e){ if(e.target.tagName==='A') m.classList.remove('open'); });
    });
  }
  function init(root){ reveal(root); menus(root); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', function(){ init(document); }); }
  else { init(document); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();